<template>
  <div id="ship">
    <div>
      <el-select v-model="paras.travelPosition" placeholder="请选择" @change="handleSearch" clearable>
        <el-option
          v-for="n in travelist"
          :key="n.key"
          :label="n.label"
          :value="n.value">
        </el-option>
      </el-select>
      <el-select v-model="paras.status" placeholder="请选择" @change="handleSearch">
        <el-option
          v-for="n in travelStatus"
          :key="n.key"
          :label="n.label"
          :value="n.value">
        </el-option>
      </el-select>
      <div style="display:inline-block">
        <el-input v-model="paras.searchKey" placeholder="请输入合同号/型号" @change="handleSearch"></el-input>
      </div>
      <div class="cardsbykeys">
          <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><el-input v-model="keys" placeholder="请输入批号" clearable @change="handleSearch3"></el-input></span>
          </div>
          <div v-for="(o) in batchgetContactList" :key="o.key" class="text item">
            {{ o.contractNum }}
          </div>
        </el-card>
      </div>
    </div>
    <div class="comond_btn">
      <el-button  @click="handleEdit(0, null)" >添加票务信息</el-button>
       <!-- <el-button @click="handleruku()">入库</el-button> -->
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="contractNum"
          label="采购合同号"
          width="">
        </el-table-column>

        <el-table-column
          prop="goodsName"
          label="商品名称"
          width="">
        </el-table-column>

        <el-table-column
          prop="model"
          label="型号"
          width="">
        </el-table-column>

        <el-table-column
          prop="netWeight"
          label="净重/公斤"
          width="">
        </el-table-column>

        <el-table-column
          prop="grossWeight"
          label="毛重/公斤"
          width="">
        </el-table-column>

        <el-table-column
          prop="packNum"
          label="包数"
          width="">
        </el-table-column>

        <el-table-column
          prop="trayNum"
          label="托盘数">
        </el-table-column>

        <el-table-column
          label="到港期">
          <template slot-scope="scope">
             <div>{{ scope.row.eta?formatime(scope.row.eta): '' }}</div>
           </template>
        </el-table-column>

        <el-table-column
          prop="ladingNo"
          label="头程提单号">
        </el-table-column>

        <el-table-column
          label="状态">
          <template slot-scope="scope">
             <div>{{ resetstatus(scope.row.travelPosition) }}</div>
           </template>
        </el-table-column>

        <el-table-column
          width="240px"
          label="操作选项">
           <template slot-scope="scope">
             <el-button
              size="mini"
              type="primary"
              @click="handleEdit(2, scope.row)">查看详情</el-button>
            <el-button
              size="mini"
              @click="handleEdit(1, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              v-if="scope.row.travelPosition !== 3"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:center;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="handleSearch2"
          :current-page="paras.pageIndex"
          :total="total">
        </el-pagination>
      </div>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="640"
        center>
        <!-- <el-form :model="form" class="detail" :rules="rules"> -->
        <el-form :model="form" class="detail">

          <el-form-item label="采购合同号" :label-width="formLabelWidth" prop="contractNum">
            <el-select v-model="form.purchaseId" placeholder="请选择" v-if="showdetail === true && sts === 0" @change="handlechangeorder">
               <el-option
                v-for="n in orderlist"
                :key="n.key"
                :label="n.contractNum"
                :value="n.id">
              </el-option>
            </el-select>
             <div v-if="sts !== 0">{{ form.contractNum }}</div>
          </el-form-item>

          <el-form-item label="清关文件" :label-width="formLabelWidth">
            <div v-if="showdetail === false">
              <el-button type="primary" @click="downloadpdf(form.packingList)" >预览下载</el-button>
            </div>
            <el-upload
              class="upload-demo"
              :data="qiniu"
              :limit="1"
              action="https://upload.qiniup.com"
              :show-file-list="true"
              :multiple="false"
              :file-list="packingList"
              v-if="showdetail === true"
              :before-upload="handleBeforeUpload3"
              :on-success="handleOnSuccess3"
              :on-remove="handleOnRemove3"
            >
            <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <el-form-item label="商品名称" :label-width="formLabelWidth" >
            <el-input v-model="form.goodsName" v-if="showdetail === true" :disabled="true"></el-input>
            <div v-if="showdetail === false">{{ form.goodsName }}</div>
          </el-form-item>

          <el-form-item label="重量(净重)" :label-width="formLabelWidth">
            <el-input v-model="form.netWeight" v-if="showdetail === true" :disabled="true">
               <el-button slot="append">公斤</el-button>
            </el-input>
            <div v-if="showdetail === false">{{ form.netWeight }}公斤</div>
          </el-form-item>
          
          <el-form-item label="型号" :label-width="formLabelWidth">
            <el-input v-model="form.model" v-if="showdetail === true" :disabled="true"></el-input>
            <div v-if="showdetail === false">{{ form.model }}</div>
          </el-form-item>

          <el-form-item label="规格" :label-width="formLabelWidth">
            <el-input v-model="form.spec" v-if="showdetail === true" :disabled="true">
               <el-button slot="append">{{ form.goodsSpec }}</el-button>
            </el-input>
            <div v-if="showdetail === false">{{ form.spec + form.goodsSpec }}</div>
          </el-form-item>

          <el-form-item label="预计开船期" :label-width="formLabelWidth">
            <!-- <el-input v-model="form.atd" v-if="showdetail === true" :disabled="true"></el-input> -->
            <div>{{ formatime(form.atd) }}</div>
          </el-form-item>

          <el-form-item label="预计到港期" :label-width="formLabelWidth">
            <!-- <el-input v-model="form.ata" v-if="showdetail === true" :disabled="true"></el-input> -->
            <div>{{ formatime(form.ata) }}</div>
          </el-form-item>

          <h3>头程相关信息(必填):</h3>

          <el-form-item label="头程提单号" :label-width="formLabelWidth" prop="destination">
            <el-input v-model="form.tsTrips[0].ladingNo" v-if="showdetail === true"></el-input>
             <div v-if="showdetail === false">{{ form.tsTrips[0].ladingNo }}</div>
          </el-form-item>

          <el-form-item label="头程航名/航次" :label-width="formLabelWidth" prop="destination">
            <el-input v-model="form.tsTrips[0].voyage" v-if="showdetail === true"></el-input>
             <div v-if="showdetail === false">{{ form.tsTrips[0].voyage }}</div>
          </el-form-item>

          <el-form-item label="头程船务公司" :label-width="formLabelWidth" prop="supplierId">
            <el-select v-model="form.tsTrips[0].shipCompanyId" placeholder="请选择" v-if="showdetail === true">
               <el-option
                v-for="item in companylist4"
                :key="item.key"
                :label="item.chineseName?item.chineseName:item.englishName"
                :value="item.id">
                <span style="float: left">{{ item.chineseName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
              </el-option>
            </el-select>
             <div v-if="showdetail === false">{{ form.tsTrips[0].shipCompanyName }}</div>
          </el-form-item>

          
           <el-form-item label="开船期" :label-width="formLabelWidth" prop="etd">
             <el-date-picker
              v-model="form.etd"
              type="date"
              v-if="showdetail === true"
              placeholder="选择日期">
            </el-date-picker>
             <div v-if="showdetail === false">{{  formatime(form.etd) }}</div>
          </el-form-item>

           <el-form-item label="柜号/封号" :label-width="formLabelWidth" prop="containerNo">
            <el-input v-model="form.containerNo" v-if="showdetail === true"></el-input>
             <div v-if="showdetail === false">{{ form.containerNo }}</div>
          </el-form-item>

          <el-form-item label="柜型" :label-width="formLabelWidth" prop="containerType">
            <el-select v-model="form.containerType" placeholder="请选择" v-if="showdetail === true">
              <el-option
                v-for="item in containerList"
                :key="item.key"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
             <div v-if="showdetail === false">{{ form.containerType === 1? '20HQ': '40HQ' }}</div>
          </el-form-item>

          <el-form-item label="重量(毛重)" :label-width="formLabelWidth" prop="grossWeight">
            <el-input v-model="form.grossWeight" v-if="showdetail === true">
              <el-button slot="append">公斤</el-button>
            </el-input>
             <div v-if="showdetail === false">{{ form.grossWeight }}公斤</div>
          </el-form-item>

          <el-form-item label="货物原产地" :label-width="formLabelWidth" prop="deliveryPlace">
            <el-input v-model="form.deliveryPlace" v-if="showdetail === true"></el-input>
             <div v-if="showdetail === false">{{ form.deliveryPlace }}</div>
          </el-form-item>

          <el-form-item label="托盘" :label-width="formLabelWidth" prop="trayNum">
            <el-input v-model="form.trayNum" v-if="showdetail === true"></el-input>
             <div v-if="showdetail === false">{{ form.trayNum }}</div>
          </el-form-item>

          <el-form-item label="包数" :label-width="formLabelWidth" prop="packNum">
            <el-input v-model="form.packNum" v-if="showdetail === true"></el-input>
             <div v-if="showdetail === false">{{ form.packNum }}</div>
          </el-form-item>

          <el-form-item label="头程费用" :label-width="formLabelWidth" prop="price">
            <el-input v-model="form.tsTrips[0].price" v-if="showdetail === true">
              <el-button slot="append">￥</el-button>
            </el-input>
             <div v-if="showdetail === false">{{ form.tsTrips[0].price }}</div>
          </el-form-item>

          <el-form-item label="大船费用" :label-width="formLabelWidth" prop="price">
            <el-input v-model="form.price" v-if="showdetail === true">
              <el-button slot="append">￥</el-button>
            </el-input>
             <div v-if="showdetail === false">{{ form.price }}</div>
          </el-form-item>
          
           <h3>二程相关信息:</h3>

          <el-form-item label="交货地码头" :label-width="formLabelWidth" prop="destination">
            <el-input v-model="form.destination" v-if="showdetail === true"></el-input>
             <div v-if="showdetail === false">{{ form.destination }}</div>
          </el-form-item>

          <el-form-item label="二程提单号" :label-width="formLabelWidth" prop="destination">
            <el-input v-model="form.tsTrips[1].ladingNo" v-if="showdetail === true"></el-input>
             <div v-if="showdetail === false">{{ form.tsTrips[1].ladingNo }}</div>
          </el-form-item>
          
          <el-form-item label="二程航名/航次" :label-width="formLabelWidth" prop="destination">
            <el-input v-model="form.tsTrips[1].voyage" v-if="showdetail === true"></el-input>
             <div v-if="showdetail === false">{{ form.tsTrips[1].voyage }}</div>
          </el-form-item>

          <el-form-item label="到港时间" :label-width="formLabelWidth" prop="eta">
             <el-date-picker
              v-model="form.eta"
              type="date"
              v-if="showdetail === true"
              placeholder="选择日期">
            </el-date-picker>
             <div v-if="showdetail === false">{{ form.eta? formatime(form.eta): '' }}</div>
          </el-form-item>


          <el-form-item label="二程船务公司" :label-width="formLabelWidth" prop="supplierId">
            <el-select v-model="form.tsTrips[1].shipCompanyId" placeholder="请选择" v-if="showdetail === true">
               <el-option
                v-for="item in companylist4"
                :key="item.key"
                :label="item.chineseName?item.chineseName:item.englishName"
                :value="item.id">
                <span style="float: left">{{ item.chineseName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
              </el-option>
            </el-select>
             <div v-if="showdetail === false">{{ form.tsTrips[1].shipCompanyName }}</div>
          </el-form-item>

          <el-form-item label="报关行" :label-width="formLabelWidth" prop="brokerId">
            <el-select v-model="form.brokerId" placeholder="请选择" v-if="showdetail === true">
               <el-option
                v-for="item in companylist5"
                :key="item.key"
                :label="item.chineseName?item.chineseName:item.englishName"
                :value="item.id">
                <span style="float: left">{{ item.chineseName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
              </el-option>
            </el-select>
             <div v-if="showdetail === false">{{ form.brokerName }}</div>
          </el-form-item>

          <el-form-item label="二程费用" :label-width="formLabelWidth" prop="price">
            <el-input v-model="form.tsTrips[1].price" v-if="showdetail === true">
              <el-button slot="append">￥</el-button>
            </el-input>
             <div v-if="showdetail === false">{{ form.tsTrips[1].price }}</div>
          </el-form-item>

          <P v-for="(n, index) in form.ttBatchNums" :key="n.key">

            <el-form-item
              :label="'批号' + parseInt(index+1)"
              :label-width="formLabelWidth"
              :prop="'ttBatchNums.' + index + '.lotNum'"
            >
              <el-input v-model="n.lotNum" placeholder="批号" v-if="showdetail === true"></el-input>
               <div v-if="showdetail === false">{{ form.ttBatchNums[index].lotNum }}</div>
            </el-form-item>

            <el-form-item label="生产日期" :label-width="formLabelWidth">
             <el-date-picker
              v-model="form.ttBatchNums[index].expiryDate"
              type="date"
              v-if="showdetail === true"
              placeholder="选择日期">
            </el-date-picker>
             <div v-if="showdetail === false">{{  formatime(form.ttBatchNums[index].expiryDate) }}</div>
          </el-form-item>

          <el-form-item label="保质期" :label-width="formLabelWidth">
             <el-date-picker
              v-model="form.ttBatchNums[index].guaranteePeriod"
              type="date"
              v-if="showdetail === true"
              placeholder="选择日期">
            </el-date-picker>
             <div v-if="showdetail === false">{{  formatime(form.ttBatchNums[index].guaranteePeriod) }}</div>
          </el-form-item>

            <el-form-item
              :label="'净重' + parseInt(index+1)"
              :label-width="formLabelWidth"
              :prop="'ttBatchNums.' + index + '.netWeight'"
            >
              <!-- :rules=" { type: 'string', required: true, message: '请输入', trigger: 'blur' }" -->
              <el-input v-model="n.netWeight" placeholder="净重" v-if="showdetail === true">
                 <el-button slot="append">公斤</el-button>
              </el-input>
              
               <div v-if="showdetail === false">{{ form.ttBatchNums[index].netWeight }}公斤</div>
            </el-form-item> 

            <el-form-item
                :label="'COA' + parseInt(index+1)"
                :label-width="formLabelWidth"
                prop="coa"
              >
              <div v-if="showdetail === false">
                  <!-- <img :src="form.ttBatchNums[index].coa" class="avatar"> -->
                  <el-button type="primary" @click="downloadpdf(form.ttBatchNums[index].coa)" >预览下载</el-button>
              </div>
              <el-upload
                class="upload-demo"
                :data="qiniu"
                action="https://upload.qiniup.com"
                :show-file-list="false"
                :multiple="false"
                v-if="showdetail === true"
                :before-upload="(file) => {return handleBeforeUpload(file, index)}"
                :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, index) }"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <!-- <img v-if="form.ttBatchNums[index].coa" :src="form.ttBatchNums[index].coa" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              </el-upload>
              <div v-if="form.ttBatchNums[index].coa && showdetail === true">
                <span>{{ form.ttBatchNums[index].coa }}</span><span @click="handleOnRemove(index)" class="removebtn">X</span>
              </div>
            </el-form-item>

            <el-button @click.prevent="removeDom(n)" type="danger" v-if="showdetail === true">删除</el-button>
          </P>

            <div style="display:flex;justify-content: flex-end">
              <el-form-item >
                <el-button @click="addDom()">新增参数</el-button>
              </el-form-item>
            </div>

          <p>
            <el-form-item label="检验检疫文件" :label-width="formLabelWidth" prop="healthCertificate">
               <div v-if="showdetail === false">
                <el-button type="primary" @click="downloadpdf(form.healthCertificate)" >预览下载</el-button>
               </div>
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="false"
                :multiple="false"
                v-if="showdetail === true"
                :before-upload="handleBeforeUpload2"
                :on-success="handleOnSuccess2"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
              <div v-if="form.healthCertificate && showdetail === true">
                <span>{{ form.healthCertificate }}</span><span @click="handleOnRemove2" class="removebtn">X</span>
              </div>
          </el-form-item>
          </p>

           <p>
            <el-form-item label="提货入库单" :label-width="formLabelWidth" >
              <div v-if="showdetail === false">
                <el-button type="primary" @click="downloadpdf(form.ladingBill)" >预览下载</el-button>
              </div>
              <el-upload
                class="upload-demo"
                :data="qiniu"
                :limit="1"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file-list="ladingBill"
                v-if="showdetail === true"
                :before-upload="handleBeforeUpload5"
                :on-success="handleOnSuccess5"
                :on-remove="handleOnRemove5"
              >
               <!-- <div v-if="form.ladingBill">{{ formatName(form.ladingBill) }}</div> -->
              <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </p>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handlesuccess(sts)">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :title="title2"
        :visible.sync="centerDialogVisible2"
        @close="handleClose"
        width="640"
        center>
        <!-- <el-form :model="form" class="detail" :rules="rules"> -->
        <el-form :model="rukuform" class="detail">
           <el-form-item label="库位" :label-width="formLabelWidth" prop="brokerId">
              <el-select v-model="rukuform.locationId" placeholder="请选择">
                <el-option
                  v-for="item in stocklocationList"
                  :key="item.key"
                  :label="item.locationName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="航运信息" :label-width="formLabelWidth" prop="brokerId">
              <el-select v-model="rukuform.shipBusinessId" placeholder="请选择">
                <el-option
                  v-for="item in list"
                  :key="item.key"
                  :label="item.contractNum"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="清关税" :label-width="formLabelWidth" prop="price">
              <el-input v-model="rukuform.clearanceDuty"></el-input>
            </el-form-item>

            <el-form-item label="清关汇率" :label-width="formLabelWidth" prop="price">
              <el-input v-model="rukuform.exchangeRate"></el-input>
            </el-form-item>

            <el-form-item label="汇率币种" :label-width="formLabelWidth" prop="brokerId">
              <el-select v-model="rukuform.currencyCode" placeholder="请选择">
                <el-option
                  v-for="item in crmcurrencyList"
                  :key="item.key"
                  :label="item.currency"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="入库时间" :label-width="formLabelWidth" prop="eta">
             <el-date-picker
              v-model="rukuform.entryTime"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <p>
            <el-form-item label="合同pdf" :label-width="formLabelWidth">
              <!-- 
                ##  token
                ##  必选参数上传地址
                ##  是否显示已上传文件列表
                ##  是否支持多选文件
                ##  上传之前
                ##  上传成功
              -->
              <el-upload
                class="upload-demo"
                :data="qiniu"
                action="https://upload.qiniup.com"
                :show-file-list="true"
                :multiple="false"
                :file="rukuform.purchaseContract"
                :before-upload="handleBeforeUpload4"
                :on-success="handleOnSuccess4"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
          </p>

          <el-form-item label="备注" :label-width="formLabelWidth" prop="price">
            <el-input v-model="rukuform.remark"></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="handleexit">取 消</el-button>
          <el-button type="primary" @click="handlesuccess2">确 定</el-button>
        </span>

      </el-dialog>

    </div>
  </div>
</template>
<script>
import { shipfindAll, qiniugetDown, shipadd, shipupdateById, shipqueryById, goodsfindAll, qiniuupload, findAll, purchasefindAll, purchasegetById, shipdelete, stockadd, stocklocationfindAll, crmcurrency, batchgetContact } from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
import moment from 'moment'
export default {
  data () {
    return {
      list: [],
      keys: '',
      batchgetContactList: [],
      orderlist: [],
      packingList: [],
      ladingBill: [],
      healthCertificate: [],
      stocklocationList: [], //  库位列表
      containerList: [
        {
          label: '20HQ',
          value: 1
        },
        {
          label: '40HQ',
          value: 2
        }
      ],
      paras: {
        searchKey: '',
        travelPosition: '',
        status: 1,
        pageIndex: 1,
        pageSize: 10
      },
      total: 0,
      searchKey: '',
      travelPosition: null, //  1，在途中；2，已清关；3，已入库。默认不传，所有
      status: 1, //  1，有效；2，无效，默认不传，所有
      crmcurrencyList: [], //  货币列表
      showdetail: false, // 显示详情
      centerDialogVisible: false,
      centerDialogVisible2: false,
      title2: '商品入库',
      rukuform: {
      },
      form: { //  新增初始化form
        tsTrips: [
          {
            tripFlag: 1,
            voyage: '',
            ladingNo: '',
            price: '',
            shipCompanyId: '',
          },
          {
            tripFlag: 2,
            voyage: '',
            ladingNo: '',
            price: '',
            shipCompanyId: '',
          },
        ],
        goodsSpec: '', // 规格
        purchaseId: null, //  合同号
        etd: '', //  开船日期
        eta: '', //  到港日期
        destination: '', //  目的地
        travelPosition: '', //  货物状态
        supplierId: '', //  供货商
        shipCompanyId: '', //  票务公司
        price: '', //  票务费用
        deliveryPlace: '', //  发货地
        goodsId: '', //  商品id
        voyage: '', //  船次
        containerNo: '', //  柜号
        packingNo: '', //  装箱单号
        ladingNo: '', //  提单号
        ladingBill: '', //  提单
        healthCertificate: '',
        packingNo: '', //  装箱单号
        packingList: '', //  装箱单
        containerType: '', //  柜型
        brokerId: '', //  报关行
        brokerCharge: '', //  报关费用
        trayNum: '', //  托盘数量
        grossWeight: '', //  毛重
        netWeight: '', //  净重
        healthCertificate: '', //  健康证
        ttBatchNums: [
          {
            lotNum: '', //  批号
            netWeight: '', //  净重
            coa: '', //  coa
          }
        ], //  
      },
      para: {
        status: 1,
        contractNum: "",
        purchaseStatus: 1,
        supplierId: "",
        goodsId: "",
        // pageIndex: 1,
        pageSize: 1000
      },
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      coa: [],
      companylist2: [], //  公司列表
      companylist4: [], //  公司列表
      companylist5: [], //  公司列表
      uploadUrl: '', //  上传地址前缀
      goodslist: [], //  商品列表
      formLabelWidth: '120px',
      sts: 0, //  0 添加, 1 编辑 2, 查看详情
      title: '', //  添加窗口标题
      
      travelist: [
        {
          label: '全部',
          value: null
        },
        {
          label: '在途中',
          value: 1
        },
        {
          label: '已清关',
          value: 2
        },
        {
          label: '已入库',
          value: 3
        },
      ],
      travelStatus: [ //  状态列表
        {
          value: null,
          label: '所有'
        },
        {
          value: 1,
          label: '有效'
        },
        {
          value: 2,
          label: '无效'
        }
      ],
      rules: {
        etd: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        eta: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        supplierId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        containerType: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        goodsId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        supplierId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        shipCompanyId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        brokerId: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        coa: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        contractNum: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        destination: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        voyage: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        price: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        deliveryPlace: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        packingNo: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        ladingNo: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        ladingBill: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        packingList: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        trayNum: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        lotNum: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        netWeight: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        brokerCharge: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        healthCertificate: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        containerNo: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
        grossWeight: [
          { type: 'string', required: true, message: '请输入', trigger: 'blur' },
        ],
      }
    }
  },
  mounted () {
    this.getshipfindAll()
    this.getToken()
  },
  methods: {
    downloadpdf (w) { // 下载
      console.log(w)
      let para = new URLSearchParams()
      para.append('baseUrl', w)
      qiniugetDown(para).then(data => {
        console.log(data.data)
        window.open(data.data)
      })
    },
    handleruku () { // 商品入库
      this.centerDialogVisible2 = true
      this.getstocklocationfindAll()
      this.travelPosition = 2
      this.getshipfindAll()
      this.getcrmcurrency()
    },
    handleClose () {
      this.getshipfindAll()
      this.centerDialogVisible2 = false
    },
    handleexit () {
      this.getshipfindAll()
      this.centerDialogVisible2 = false
    },
    handlesuccess2 () {
      this.rukuform.entryTime = this.formatime(this.rukuform.entryTime)
      let para = new URLSearchParams(this.rukuform)
      stockadd(para).then(data => {
        console.log(data)
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getshipfindAll()
          this.centerDialogVisible2 = false
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    getstocklocationfindAll () { //  查询
      let para = {
        'status': 1
      }
      stocklocationfindAll(para).then(data => {
        console.log(data)
        this.stocklocationList = data.data.data
      })
    },
    getcrmcurrency () { //  货币列表
      let para = {}
      crmcurrency(para).then(data => {
        console.log(data)
        this.crmcurrencyList = data.data.data
      })
    },
    getbatchgetContact () { //  批号
      let para = {
        key:this.keys
      }
      batchgetContact(para).then(data => {
        console.log(data)
        this.batchgetContactList = data.data.data
      })
    },
    handlechangeorder (val) {
      let para = {
        id: val
      }
      purchasegetById(para).then(data => {
        console.log(data)
        let res = data.data.data
        this.form.goodsName = res.goodsName
        this.form.netWeight = res.netWeight
        this.form.model = res.model
        this.form.spec = res.spec
        this.form.ata = res.ata
        this.form.atd = res.atd
        this.form.goodsSpec = res.goodsSpec
      })
    },
    getorderqueryList (obj) { //  查询采购订单
      let para = obj
      purchasefindAll(para).then(data => {
        console.log(data)
        if (data.data.data.rows) {
          this.orderlist = data.data.data.rows
        } else {
          this.orderlist = []
        }
      })
    },
    getToken () { //  获取qiniu的token
      let para = new URLSearchParams()
      para.append('bucket', 'crm-sea-transportation')
      qiniuupload(para).then((res) => {
        console.log(res.data)
        this.qiniu.token = res.data.uploadToken
        this.uploadUrl = res.data.url
      })
    },
    queryCompany (t) {
      let para = {
        'status': 1,
        'typeId': t
      }
      console.log(1)
      findAll(para).then(data => {
        console.log(data)
        if (t === 2) {
          this.companylist2 = data.data.data
        } else if (t === 4) {
          this.companylist4 = data.data.data
        } else if (t === 5) {
          this.companylist5 = data.data.data
        }
      })
    },
    handleBeforeUpload (file, index) { //  上传之前
      this.qiniu.key = `ship${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess (response, file, fileList, index) { //  上传成功之后
      console.log(response, file, fileList, index)
      this.form.ttBatchNums[index].coa = this.uploadUrl + response.key
      console.log(this.form.ttBatchNums[index].coa)
    },
    handleOnRemove (index) {
      console.log(index)
      this.form.ttBatchNums[index].coa = null
      // this.form.ttBatchNums[index].coa = []
      // this.coa[index] = []
    },
    
    handleBeforeUpload3 (file) { //  上传之前
      console.log(file)
      console.log(file.type)
      this.qiniu.key = `packingList${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess3 (response, file, fileList) { //  上传成功之后
      this.form.packingList = this.uploadUrl + response.key
      this.packingList.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
      console.log(this.packingList)
    },
    handleOnRemove3 (file, fileList) {
      this.packingList = []
      console.log(file, fileList)
    },
    handleBeforeUpload4 (file) { //  上传之前
      this.qiniu.key = `purchaseContract${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess4 (response, file, fileList) { //  上传成功之后
      this.rukuform.purchaseContract = this.uploadUrl + '/' + response.key
    },
    handleBeforeUpload5 (file) { //  上传之前
      this.qiniu.key = `ladingBill${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess5 (response, file, fileList) { //  上传成功之后
      this.form.ladingBill = this.uploadUrl + '/' + response.key
      this.ladingBill.push({
        name: response.key,
        url: this.uploadUrl + response.key
      })
    },
    handleOnRemove5 (file, fileList) {
      this.ladingBill = []
      console.log(file, fileList)
    },
    handleBeforeUpload2 (file) { //  上传之前
      this.qiniu.key = `healthCertificate${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    handleOnSuccess2 (response, file, fileList) { //  上传成功之后
      this.form.healthCertificate = this.uploadUrl + '/' + response.key
    },
    handleOnRemove2 (file, fileList) { //  上传成功之后
      this.form.healthCertificate = null
    },
     /**
     * 多元素删除与添加
     */
    removeDom (item) { //  删除元素
      let dom = this.form.ttBatchNums
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        var index = dom.indexOf(item)
        if (index !== -1) {
          dom.splice(index, 1)
        }
      }
    },
    addDom () { //  增加参数
      this.form.ttBatchNums.push({
        lotNum: '', //  批号
        netWeight: '', //  净重
        coa: '', //  coa
      })
    },
    handleSearch () {
      this.getshipfindAll()
    },
    handleSearch2 (val) {
      this.paras.pageIndex = val
      this.getshipfindAll()
    },
    handleSearch3 () {
      this.getbatchgetContact()
    },
    handleEdit (ind, row) { //  编辑或者新增
      console.log(row)
      this.centerDialogVisible = true
      this.queryCompany(2)
      this.queryCompany(4)
      this.queryCompany(5)
      this.getorderqueryList(this.para) //  采购合同号
      this.containerList = [
        {
          label: '20HQ',
          value: 1
        },
        {
          label: '40HQ',
          value: 2
        }
      ]
      if (ind === 1) {
        this.showdetail = true
        this.title = '编辑票务信息'
        this.form.id = row.id
        this.getshipqueryById(row.id)
        this.sts = 1
      } else if (ind === 0) {
        this.packingList = []
        this.ladingBill = []
        this.healthCertificate = []
        this.showdetail = true
        this.title = '新增票务信息'
        this.form = {}
        this.form  = {
          healthCertificate: '',
          goodsName: '',
          netWeight: '',
          model: '',
          packingList: '',
          spec: '',
          ladingBill: '',
          tsTrips: [
            {
              tripFlag: 1,
              voyage: '',
              ladingNo: '',
              price: '',
              shipCompanyId: '',
            },
            {
              tripFlag: 2,
              voyage: '',
              ladingNo: '',
              price: '',
              shipCompanyId: '',
            },
          ],
          ttBatchNums:[
            {
              lotNum: '', //  批号
              netWeight: '', //  净重
              coa: '', //  coa
            }
          ], // 
        }
        this.sts = 0
      } else {
        this.showdetail = false
        this.getshipqueryById(row.id)
        console.log(this.form)
        this.sts = 2 //  查看详情
        this.title = '票务信息详情'
      }
    },
    handlesuccess (sts) { //  提交修改信息
      if (sts === 0) {
        let para = new URLSearchParams()
        para.append('ticketBusiness', JSON.stringify(this.form))
        shipadd(para).then(data => {
          console.log(data)
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getshipfindAll()
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else if (sts === 1) {
        //  修改信息
        let para = new URLSearchParams()
        para.append('ticketBusiness', JSON.stringify(this.form))
        shipupdateById(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getshipfindAll()
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else {
        //  查看详情
        this.centerDialogVisible = false
      }
    },
    handleDelete (ind, row) { //  删除
      let para = new URLSearchParams()
      para.append('id', row.id)
      para.append('status', 2)
      shipdelete(para).then(data => {
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getshipfindAll()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
      console.log(ind, row)
    },
    getshipfindAll () { //  查询船务列表
      // let params = {
      //   travelPosition: t, //  1，在途中；2，已清关；3，已入库。默认不传，所有
      //   status: s, //  1，有效；2，无效，默认不传，所有
      //   searchKey: k
      // }
      shipfindAll(this.paras).then(data => {
        console.log(data)
        this.total = data.data.data.total
        this.list = data.data.data.rows
      })
    },
    getshipqueryById (id) { //  获取票务详情
      let para = {
        id: id
      }
      shipqueryById(para).then(data => {
        console.log(data)
        this.form = data.data.data
        this.packingList = []
        this.ladingBill = []
        this.healthCertificate = []
        this.packingList.push({
          name: this.formatName(this.form.packingList),
          url: this.form.packingList
        })
        this.ladingBill.push({  
          name: this.formatName(this.form.ladingBill),
          url: this.form.ladingBill
        })
        this.healthCertificate.push({  
          name: this.formatName(this.form.healthCertificate),
          url: this.form.healthCertificate
        })
        if (this.form.ladingBill === '') {
          this.ladingBill = []
        }
        if (this.form.healthCertificate === '') {
          this.healthCertificate = []
        }
      })
    },
    getgoodsfindAll (t, s) { //  查询商品信息
      let para = {
        typeId: t,
        status: s
      }
      goodsfindAll(para).then(data => {
        console.log(data)
        this.goodslist = data.data.data
      })
    },
    getcompanyfindAll (t, s) { //  公司列表
      let para = {
        typeId: t,
        status: s
      }
      findAll(para).then(data => {
        console.log(data)
        this.companylist = data.data.data
      })
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
    formatName (s) {
      // "http://seatransportation.cuican520.cn/packingList201902261115793321.zip"
      return s.substr(38)
    },
    resetstatus (s) {
      switch (s) {
        case 1:
          return "在途中"
          break
        case 2:
          return "已清关"
          break
        case 3:
          return "已入库"
          break
      }
    }
  }
}
</script>
<style lang="stylus">
#ship
  .removebtn
    display inline-block
    font-size 16px
    margin-left 15px
    cursor: pointer
  .comond_btn
    display flex
    justify-content flex-end
    margin-bottom 80px
    button
      background-color #0a3d5f
      color #fff
  .detail>div
    display inline-block
    width 49%
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}

.box-card {
  width: 480px;
}
.cardsbykeys {
  position: absolute;
  z-index: 2;
}
</style>
